export const xlsxDownloadPrefix = "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,";
